export const MODALS = Object.freeze({
  AUTH: {
    ENTRY_POINT: "AUTH_ENTRY_POINT",
    LOGIN: "AUTH_LOGIN",
    REGISTRATION: "AUTH_REGISTRATION",
    FORGOT_PASSWORD: "AUTH_FORGOT_PASSWORD",
    RESET_PASSWORD: "AUTH_RESET_PASSWORD",
    EMAIL_CONFIRM: "AUTH_EMAIL_CONFIRM",
    CHECK_EMAIL_CONFIRM: "AUTH_CHECK_EMAIL_CONFIRM",
    WELCOME: "AUTH_WELCOME",
    PRIVATE_COURSE_SIGNUP: "AUTH_PRIVATE_COURSE_SIGNUP",
    ONBOARDING: {
      COUNTDOWN: "AUTH_ONBOARDING_COUNTDOWN",
      PERSONAL_DATA: "AUTH_ONBOARDING_PERSONAL_DATA",
      PROFESSIONAL_DATA: "AUTH_ONBOARDING_PROFESSIONAL_DATA",
    },
    USER_INACTIVITY: "AUTH_USER_INACTIVITY",
    LICENSE_PENDING: "AUTH_LICENSE_PENDING",
  },
  TEST: {
    EXTERNAL_CERTIFICATE_CHECKOUT: "TEST_EXTERNAL_CERTIFICATE_CHECKOUT",
  },
})
